import "core-js/modules/es6.regexp.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { putAction } from '@/api/manage';
export default {
  name: 'UserPassword',
  data: function data() {
    return {
      title: '修改密码',
      modalWidth: 800,
      visible: false,
      confirmLoading: false,
      validatorRules: {
        oldpassword: {
          rules: [{
            required: true,
            message: '请输入旧密码!'
          }]
        },
        password: {
          rules: [{
            required: true,
            message: '请输入新密码!'
          }, {
            validator: this.validateToNextPassword
          }]
        },
        confirmpassword: {
          rules: [{
            required: true,
            message: '请确认新密码!'
          }, {
            validator: this.compareToFirstPassword
          }]
        }
      },
      confirmDirty: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      form: this.$form.createForm(this),
      url: 'auth/updatePassword',
      username: ''
    };
  },
  methods: {
    show: function show(uname) {
      if (!uname) {
        this.$message.warning('当前系统无登陆用户!');
        return;
      } else {
        this.username = uname;
        this.form.resetFields();
        this.visible = true;
      }
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
    },
    handleOk: function handleOk() {
      var _this = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        console.log('confirmLoading', err, values);

        if (!err) {
          that.confirmLoading = true;
          var params = Object.assign({
            username: _this.username
          }, values);
          params.tenantId = window.localStorage.getItem('tenant') ? window.localStorage.getItem('tenant') : 0;
          console.log('修改密码提交数据', params);
          putAction(_this.url, params).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      console.log('value', value);
      var form = this.form;
      var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{9,16}');

      if (regex.test(value)) {
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], {
            force: true
          });
        }
      } else {
        callback('请输入8~16位数字和字母及符号组合的密码！');
      }

      callback();
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;

      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！');
      } else {
        callback();
      }
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    }
  }
};